import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=a46edbbc&scoped=true&"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=a46edbbc&scoped=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46edbbc",
  null
  
)

export default component.exports